import {
  StyledCheck,
  StyledCheckBoxProps,
  StyledLabel,
} from "components/parts/Input/CheckBox/styled";
import React from "react";

export type PresenterProps = {
  id: string;
  onClick?: React.MouseEventHandler<HTMLLabelElement>;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
} & StyledCheckBoxProps;

export const CheckBoxPresenter: React.FC<PresenterProps> = ({
  id,
  onClick,
  checked,
  onChange,
}) => {
  return (
    <StyledLabel id={`checkbox-${id}`} checked={checked} onClick={onClick}>
      <StyledCheck checked={checked} />
      <input
        type="checkbox"
        name="checkbox"
        id={`checkbox-${id}`}
        checked={checked}
        onChange={onChange}
      />
    </StyledLabel>
  );
};
